import React, { Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import {
    Row,
    Col,
    Form,
    Label,
    Button
} from "reactstrap";
import axios from "axios";
import {toast} from "react-toastify";

const ClientData = ({ setSteps, setFormdata, formdata, initial_gps, setShowForm, valetName, valetId }) => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            phone: formdata.phone || "",
            full_name: formdata.full_name || "",
        },
    });

    const [clientFound, setClientFound] = useState(false);
    const [clientData, setClientData] = useState(null);

    const searchClient = async (phone) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_PUBLIC_SERVER}/api/customers/search/${phone}`);
            if (response.status === 200 && response.data) {
                return response.data;
            }
        } catch (error) {
            return null;
        }
    };

    const handlePhoneChange = async (e) => {
        const phone = e.target.value;
        const data = await searchClient(phone);
        if (data) {
            setValue("full_name", data.full_name);
            setClientData(data);
            setClientFound(true);
        } else {
            setValue("full_name", "");
            setClientData(null);
            setClientFound(false);
        }
    };

    const onSubmit = async (data) => {
        const clientData = await searchClient(data.phone);
        if (clientData) {
            if (valetName) {
                setFormdata((prev) => ({
                    ...prev,
                    id_customer: clientData.id,
                    full_name: clientData.full_name,
                    email: clientData.email,
                    phone: clientData.phone_number,
                    fiscal_identification: clientData.fiscal_identification,
                    car_model: clientData.car_model,
                    car_type:clientData.car_type,
                    car_identification: clientData.car_identification,
                    user_id: clientData.user_id,
                    initial_gps,
                    id_valet: valetId,
                    valet_name: valetName,
                }));
                setValue("full_name", clientData.full_name);
                setSteps((prev) => prev + 1);
            } else {
                toast.error("No se encontró el nombre del valet en la sesión");
            }
        }
    };
    return (
        <Fragment>
            <Row>
                <Col sm="12">
                    <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
                        <div className="dflex">
                            <Col md="12 mb-3">
                                <Label className="form-label">Teléfono del Cliente</Label>
                                <input
                                    className="form-control"
                                    name="phone"
                                    type="text"
                                    placeholder="+12312312"
                                    {...register("phone", { required: "Num. Teléfono es requerido" })}
                                    onChange={handlePhoneChange}
                                />
                                {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                            </Col>
                            <Col md="12 mb-3">
                                <Label className="form-label">Nombre del Cliente</Label>
                                <input
                                    className="form-control"
                                    name="full_name"
                                    type="text"
                                    placeholder="Nombre"
                                    readOnly={true}
                                    {...register("full_name")}
                                />
                            </Col>
                            <Col md="12 mb-3">
                                <Label className="form-label">Coordenadas Iniciales de Recogida</Label>
                                <input
                                    className="form-control"
                                    name="initial_gps"
                                    value={initial_gps}
                                    type="text"
                                    placeholder="10.000 -10.000"
                                    readOnly={true}
                                />
                            </Col>
                            <div className="text-end">
                                <Button className="form-control-sm btn-success" type="submit">
                                    Siguiente
                                </Button>
                                <Button
                                    className="form-control-sm btn-danger"
                                    onClick={() => setShowForm(false)}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ClientData;
